import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Button } from '@fiverr-private/button';
import { I18n } from '@fiverr-private/i18n-react';
import { ElementType } from '@fiverr-private/bianka_js';
import { reportClick } from '../../utils/biEvents/events/biankaEvents';

const LONG_TERM_HIRING_URL = 'https://pro.fiverr.com/cp/dm-long-term-hiring';

export const HireFreelancerTab = () => {
    const onButtonClick = () => {
        reportClick({
            eventName: 'clicked_on_get_started_lohp',
            elementType: ElementType.BUTTON,
            elementName: 'get_started_lohp',
        });

        window.location.href = LONG_TERM_HIRING_URL;
    };

    return (
        <Stack direction="column" gap="7" maxWidth="434px">
            <Typography color="white" size="b_md">
                <I18n k="logged_out_homepage.video_top_banner.long_term_hiring_experiment.hire_freelancer_tab.description" />
            </Typography>
            <Container maxWidth="220px">
                <Button colorScheme="white" variant="filled" size="sm" fullWidth onClick={onButtonClick}>
                    <I18n k="logged_out_homepage.video_top_banner.long_term_hiring_experiment.hire_freelancer_tab.button" />
                </Button>
            </Container>
        </Stack>
    );
};
